/* eslint-disable react/prop-types */
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import React, { useEffect, useState } from 'react';
import { round } from 'lodash';
import { Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent,
  DatasetComponent
]);

const getOption = (data, colors, series, unit) => {
  const locations = Object.keys(data);
  const legendData = locations;

  const seriesData = locations.map((location, index) => ({
    name: location,
    type: 'bar',
    data: data[location],
    color: colors[index % colors.length]
  }));

  return {
    color: colors,
    tooltip: {
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('dark') },
      borderWidth: 1,
      transitionDuration: 0,
      valueFormatter: function (value) {
        return value + ` ${unit}`;
      }
    },
    grid: {
      right: '5%',
      left: '5%',
      bottom: '10%',
      containLabel: true
    },
    legend: {
      data: legendData,
      icon: 'circle'
    },
    xAxis: [
      {
        type: 'category',
        data: series
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: true
        },
        axisLabel: {
          formatter: `{value} ${unit}`
        }
      }
    ],
    series: seriesData
  };
};

const MultiParamSeasonalChart = ({ chartData }) => {
  const [selectedYear, setSelectedYear] = useState(
    Object.keys(chartData.variant)[0]
  );
  const [selectedSeason, setSelectedSeason] = useState(
    chartData.variant[selectedYear][0]
  );
  const [selectedData, setSelectedData] = useState({});
  // const colors = ['#5470C6', '#91CC75', '#EE6666', '#FF5733'];
  const colors = ['#5470C6', '#91CC75', '#ff4f4f', '#C966ED'];

  useEffect(() => {
    if (selectedYear && selectedSeason) {
      setSelectedData(chartData.data[selectedYear][selectedSeason]);
    }
  }, [selectedYear, selectedSeason, chartData]);

  const handleYearChange = event => {
    const newYear = event.target.value;
    setSelectedYear(newYear);
    setSelectedSeason(chartData.variant[newYear][0]);
  };

  const handleSeasonChange = event => {
    setSelectedSeason(event.target.value);
  };

  return (
    <Card className="h-100">
      <FalconCardHeader
        title={chartData.label}
        titleTag="h5"
        light={true}
        desc={chartData.description.Definition}
        endEl={
          Object.keys(chartData.variant).length > 1 && (
            <Row className="align-items-center">
              <Col className="col-auto">
                <Form.Select value={selectedYear} onChange={handleYearChange}>
                  {Object.keys(chartData.variant).map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col className="col-auto">
                <Form.Select
                  value={selectedSeason}
                  onChange={handleSeasonChange}
                  id="season"
                  name="season"
                >
                  {chartData.variant[selectedYear].map(season => (
                    <option key={season} value={season}>
                      {season}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          )
        }
      />
      <Card.Body className="h-100 position-relative" dir="ltr">
        <ReactEChartsCore
          echarts={echarts}
          option={getOption(
            selectedData,
            colors,
            chartData.series,
            chartData.unit
          )}
          style={{ minHeight: '25.75rem' }}
        />
        <p
          style={{
            fontSize: '12px',
            position: 'absolute',
            top: '20px',
            right: '20px'
          }}
        >
          {chartData.unit}
        </p>
      </Card.Body>
    </Card>
  );
};

export default MultiParamSeasonalChart;
